import Button from '@pelckmans/elementis/components/button';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

const TRANSLATION_BASE = 'SHARED_COMPONENTS.NO_CONTENT';

interface Props {
  title: string;
  children: ReactNode;
  onClearFiltersClick?: () => void;
}

export default function NoContent({ title, children, onClearFiltersClick }: Props) {
  const { t } = useTranslation();

  return (
    <div className="no-content">
      <div className="no-content__message">
        <p className="title">{title}</p>
        <p className="text">{children}</p>
      </div>
      {onClearFiltersClick ? (
        <div className="no-content__action">
          <Button prominence="neutral" size="sm" onClick={onClearFiltersClick}>
            {t(`${TRANSLATION_BASE}.CLEAR`)}
          </Button>
        </div>
      ) : null}
    </div>
  );
}
